<template>
  <div :style="{minHeight:'600px'}">
    <div class="head">
      <h2>
        <b>{{$t('title.w33')}}</b>
        <small>Investment list</small>
      </h2>
    </div>
    <InvestFilter @change="v=>dataFilter=v"/>
    <Datatable
      url="/Member/RZJLoan/InvestmentLoanSchemeList"
      field="InvesLoanSchemeList"
      :th="[$t('label.w16'),$t('label.w3'),$t('label.w17'),$t('label.w18'),$t('label.w19')]"
      v-slot="{item}"
      :filter="dataFilter"
      :tip="$t('msg.m120')"
    >
      <tr>
        <td class="td1">
          <p v-if="item.LoanType===0">{{$t('label.w10')}}{{item.Amount | cn}}</p>
          <p v-if="item.LoanType===1">{{$t('label.w170')}}{{item.Amount | cn}}</p>
          <p v-if="item.LoanType===2"><span class="text-primary">{{$t('label.w171')}}{{item.Amount | cn}}</span></p>
          <p v-if="item.Progress!=100">{{item.FakeOwnerName}} | {{item.Number}}</p>
          <p v-if="item.Progress==100">{{item.FakeOwnerName | name}} | {{item.Number}}</p>
        </td>
        <td class="td2">{{item.Rate.toFixed(1)}}%{{item.AddRate==0?'':`+${item.AddRate}%`}}</td>
        <td
          class="td3"
        >{{item.LoanCycleValue<30?item.LoanCycleValue+$t('label.w15'):(item.LoanCycleValue/30)+$t('label.w14')}}</td>
        <td class="td4">
          <p>￥{{item.CurrentAmount | money}}/￥{{item.Amount | money}}</p>
          <p>
            <Progress
              :percent="item.Progress<1 && item.Progress!=0 ? 1:item.Progress"
              hide-info
              :style="{width:'200px'}"
              stroke-color="#749EFC"
            />
          </p>
        </td>
        <td class="td5">
          <router-link :class="{finished:item.Progress>=100}" :to="{name:'borrowDetails',params:{id:item.Id}}">{{item.Progress<100?$t('nav.w72'):$t('nav.w73')}}</router-link>
        </td>
      </tr>
    </Datatable>
  </div>
</template>
<script>
import Datatable from "@/components/datatable";
import InvestFilter from "@/components/investFilter";
export default {
  components: { Datatable, InvestFilter },
  data() {
    return {
      dataFilter:{}
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.head {
  margin-bottom: 20px;
  h2 {
    font-weight: normal;
    > b {
      font-size: 24px;
      display: block;
      color: #232325;
    }
    > small {
      display: block;
      color: #7b7b7c;
      font-size: 12px;
      text-transform: uppercase;
    }
  }
}
td {
  padding: 20px 0;
}
.td1 {
  text-align: left;
  padding-left: 30px;
  width: 18%;
  p:first-child {
    height: 22px;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
    margin-bottom: 4px;
  }
  p:last-child {
    height: 17px;
    font-size: 12px;
    color: rgba(123, 123, 124, 1);
    line-height: 17px;
  }
}
.td2 {
  height: 29px;
  width: 14%;
  font-size: 24px;
  font-family: DIN-Medium;
  color: rgba(255, 97, 6, 1);
  line-height: 29px;
}
.td3 {
  height: 22px;
  width: 14%;
  font-size: 16px;
  color: #333;
  line-height: 22px;
}
.td4 {
  width: 28%;
  p:first-child {
    height: 17px;
    font-size: 12px;
    color: rgba(51, 51, 51, 1);
    line-height: 17px;
  }
}
.td5 {
  width: 25%;
  a {
    display: inline-block;
    width: 120px;
    height: 36px;
    line-height: 36px;
    color: #fff;
    background: linear-gradient(
      90deg,
      rgba(249, 195, 72, 1) 0%,
      rgba(255, 129, 58, 1) 100%
    );
    border-radius: 20px;
    &.finished{
      background:linear-gradient(90deg,rgba(129,169,250,1) 0%,rgba(74,112,242,1) 100%);
    }
  }
}
</style>
